import { render, staticRenderFns } from "./AssignNumberModal.vue?vue&type=template&id=2f475350&"
import script from "./AssignNumberModal.vue?vue&type=script&lang=js&"
export * from "./AssignNumberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports